<template>
  <section class='leaveStu'>
    <Row>
      <Breadcrumb>
        <BreadcrumbItem to="">权限管理</BreadcrumbItem>
        <BreadcrumbItem to="">便民惠企</BreadcrumbItem>
      </Breadcrumb>
    </Row>
    <Row xs="20" sm="16" md="12" lg="8">

      <Col span='4'>
      <Input v-model="searchParam.title" placeholder="" />
      </Col>

      <Col span='4'>
      <Button type="info" @click='searchData'>查询</Button>
      </Col>

    </Row>


    <div style='display:flex;justify-content:space-between;margin-top:20px;'>
      <div id='pdData' class='pdData'>
        <div :class='[index == curIndex ? "active" : ""]' class='itempd' v-for='(item, index) in departlist'
          :key='item.guid' @click='tabPD(item, index)'>{{ item.name }}</div>

      </div>
      <ul class='conheadRight'>

        <Button type="error" @click='getId(-1)'>新增</Button>
      </ul>

    </div>
    <section class='tabelContent'>
      <tablePage border :queryData="queryData" :issearch='issearch'></tablePage>
    </section>

    <Modal v-model='editModal' width='600px' title='新增/修改' @on-ok='updateLesson'>
      <Form :model="formItem" :label-width="100">
        <FormItem label="排序">
          <Input v-model="formItem.sort" placeholder=""></Input>
        </FormItem>
        <FormItem label="服务事项">
          <Input v-model="formItem.name" placeholder=""></Input>
        </FormItem>
        <FormItem label="服务群体">
          <Input v-model="formItem.serviceremark" placeholder=""></Input>
        </FormItem>
        <FormItem label="服务方式">
          <Input v-model="formItem.remark" placeholder=""></Input>
        </FormItem>
        <FormItem label="便民惠企电话">
          <Input type='text' v-model="formItem.phone" placeholder=""></Input>
        </FormItem>
      </Form>
    </Modal>

  </section>
</template>

<script>
import tablePage from './tablePage'
import bemodal from './formItem'
import utils from '../utils/index'
import imxls from './imXLSNewTemp'
export default {
  name: 'noticelist',
  components: {
    tablePage,
    bemodal,
    imxls
  },
  data () {
    return {
      editModal: false,
      addStaffModal: false,
      usercard: '',
      username: '',
      userphone: '',
      userdepart: '',
      editCard: false,
      showxls: false,
      exportExcelData: {
        excelTitle: '员工充值模板',
        thead: ['姓名', '电话', '金额', '备注'],
        filterVal: ['name', 'phone', 'amount', 'remark'],
        // mockData:['张三',  '17710582636', '22', '5月份饭卡钱'],
        mockData: [],
        curUrl: 'canteenAmountRecord/saveBatch',
        downUrl: '',
      },
      downUrl: '',
      editDepart: false,
      changeDepartid: '',
      unionid: '',
      changeDepartUnionid: '',
      edituser: false,
      departlist: [],
      curIndex: 0,
      formItem: {
        guid: '',
        name: '',
        remark: '',
        serviceremark: '',
        phone: '',
        sort: '',
        pid: '',
        rootid: 'departid',
      },
      addMoney: false,
      hisData: '',
      columnshis: [],
      showhis: false,
      showpay: false,
      smodal: false,
      reloadTmep: -1,
      initformData: [],

      queryData: ['',
        [{
          title: '服务事项（内容）',
          key: 'name',
          width: 200,
          ellipsis: true,
        },
        {
          title: '服务群体',
          key: 'serviceremark',
          align: 'center',
        },
        {
          title: '服务方式 ',
          key: 'remark',
          align: 'center',
        },
        {
          title: '便民惠企电话 ',
          key: 'phone',
          align: 'center',
        },
        {
          title: '',
          slot: 'action',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  display: 'inline-block',
                  width: '60px',
                  height: '25px',
                  background: '#2db7f5',
                  borderRadius: '6px',
                  textAlign: 'center',
                  lineHeight: '25px',
                  color: '#fff',
                  fontSize: '12px',
                  cursor: 'pointer',
                  userSelect: 'none'
                },
                on: {
                  click: () => {


                    this.curStuInfo = params.row

                    this.getId(params.row.guid)


                  }
                }
              }, '编辑')
            ])
            // <span class='do' @click="show(index,row)">编辑</span>
          }
        },
        ]
      ],
      searchParam: {
        rootid: "depart",
        notice: '',
        pid: '',
      },
      issearch: -1,
      isshowpay: -1,
      isshowhis: -1,
      userInfo: {},
      curGuid: '',
    }
  },
  mounted () {

    this.userInfo = JSON.parse(localStorage.getItem('inchUserinfo'))
    this.getDepart()
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.tagName === 'INPUT') {
        e.preventDefault();
      }
    });
  },
  methods: {
    getId (guid) {
      var that = this
      this.editModal = true
      if (guid == -1) {
        this.formItem = {
          guid: '',
          name: '',
          remark: '',
          serviceremark: '',
          phone: '',
          sort: '',
          pid: that.curItem.guid,
          rootid: 'departid',
        }
        console.log(this.formItem)
      } else {
        var param = {
          id: guid,
        }

        this.axios.get('dic/getId', { params: param }).then(res => {
          console.log(res, 'res')
          var curItem = res.data
          that.formItem = {
            guid: curItem.guid,
            name: curItem.name,
            remark: curItem.remark,
            serviceremark: curItem.serviceremark,
            phone: curItem.phone,
            sort: curItem.sort,
            pid: curItem.pid,
            rootid: curItem.rootid,
          }
        })
      }

    },
    updateLesson () {
      var that = this

      this.axios.post('dic/save', that.formItem).then(res => {
        console.log(res, 'res')
        that.formItem = {
          guid: '',
          name: '',
          remark: '',
          serviceremark: '',
          phone: '',
          sort: '',
          pid: '',
          rootid: 'departid',
        }
        that.searchData()
      })
    },
    changeDepartMethod () {
      console.log(this.changeDepartid)
      var that = this
      var param = {
        departid: this.changeDepartid,
        guid: this.changeDepartUserid,
        unionid: this.changeDepartUnionid
      }


      this.axios.post('appUser/changeDepart', param).then(res => {
        if (res.success) {
          that.$Message.info(res.msg)
          that.reloadTable()
          that.editDepart = false
        } else {
          that.$Message.error(res.msg)
        }
      })
    },

    getDepart () {
      var that = this
      this.axios.get('dic/getQueryList', { params: { rootid: 'depart', pid: 0, length: -1 } }).then((a) => {
        console.log(a, 'a')
        that.curItem = a['data'][0]
        that.departlist = a.data
        that.queryData[0] = 'dic/getQueryList?length=-1&pageno=1&pid=' + that.curItem['guid']
        that.searchData()
      })

    },
    tabPD (item, index) {
      console.log(item, index)
      var that = this
      this.curIndex = index
      this.curItem = item
      that.queryData[0] = 'dic/getQueryList?length=-1&pageno=1&pid=' + item['guid']
      that.searchData()
    },
    getHisData (name, row) {
      this.showhis = true
      this.isshowhis = Math.random()
      var url = this.columnshis[0].split("?")[0]
      this.columnshis[0] = url + '?name=' + name
    },
    getPayData (name, row) {
      console.log(row, 'row')
      this.showpay = true
      this.isshowpay = Math.random()
      var url = this.payhis[0].split("?")[0]
      // this.payhis[0] = url+'?name='+name
      this.payhis[0] = url + '?userid=' + row.guid
    },
    searchData () {
      this.issearch = Math.random()
    },
    reloadTable () {
      this.issearch = Math.random()
    },
  }
}
</script>

<style scoped>
.tabelContent {
  margin-top: 20px;
}

.leaveStu {
  flex: 1;
  padding-right: 25px !important;
  /* overflow: scroll; */
  padding-bottom: 50px;
  padding-top: 20px;
  overflow-x: hidden;
}

.leaveStu .ivu-row:first-of-type {
  margin-top: 5px;
}

.leaveStu .ivu-row {
  margin-top: 20px;
  /* 	overflow:hidden; */
  position: relative;
}

.leaveStu .ivu-col {
  margin-right: 10px;
  /* float:left; */
}

.leaveStu .ivu-col:last-of-type {
  float: left;
  margin-left: 0px;
  /* position:absolute;
		right:0px; */
}

.demo-upload-list {



  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  overflow: hidden;
  margin-right: 4px;
  margin-bottom: 5px;
}

.demo-upload-list img {
  width: 40px;
  height: 40px;
  float: left;
  margin-right: 15px;
}

.demo-upload-list span {
  line-height: 40px;
  font-size: 12px;
  float: left;
}

.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .6);
}

.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}

.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 10px;
  line-height: 40px;

}

#hwSchool {
  position: relative;
}

#hwSchool .ivu-tree {
  position: absolute;
  top: 33px;
  left: 0px;
  background: #fff;
  z-index: 1000;
  width: 300px;
  height: 300px;
  border: 1px solid #dcdee2;
  border-top: 0 none;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-left: 10px;
}

.modalUl {
  width: 100%;
  display: flex;
  justify-content: space-between;


}

.modalUl li {
  list-style: none;

}

.modalUl>li:first-of-type {
  width: 35%;
  height: 100%;
  height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.modalUl>li:last-of-type {
  flex: 1;
  padding-left: 30px;
}

.treeContent {}

.hwImgCon {
  margin-top: 10px;

}

.hwImgCon img {
  width: 55px;
  height: 55px;
  border-radius: 5px;
}

.conheadRight {
  display: flex;
  justify-content: space-between
}

.pdData {
  display: flex;
  justify-content: flex-start;
  list-style: none;
  flex-wrap: wrap;
}

.itempd {
  height: 32px;
  line-height: 32px;
  border-radius: 20px;
  padding: 0 15px;
  font-size: 14px;
  margin-right: 10px;
  cursor: pointer
}

.itempd.active {
  background-color: #00d186;
  border-color: #00d186;
  color: #fff;
}

.remove {
  float: left;
}
</style>
